import { render, staticRenderFns } from "./VendorInvoiceEmail.vue?vue&type=template&id=649f0052"
import script from "./VendorInvoiceEmail.vue?vue&type=script&lang=js"
export * from "./VendorInvoiceEmail.vue?vue&type=script&lang=js"
import style0 from "./VendorInvoiceEmail.vue?vue&type=style&index=0&id=649f0052&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports